import { render, staticRenderFns } from "./PetugasTc.vue?vue&type=template&id=b79e4876&"
import script from "./PetugasTc.vue?vue&type=script&lang=js&"
export * from "./PetugasTc.vue?vue&type=script&lang=js&"
import style0 from "./PetugasTc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports